import { FIGMA_SPEC } from './figmaSpec';

const FRAME = FIGMA_SPEC.camera.frame;

/** Shared portrait frame aspect (camera viewfinder = result card) */
export const GOLD_FRAME_ASPECT = FRAME.w / FRAME.h;

/** Screenshot size (~2× booth frame) so preview is not upscaled soft on retina */
export function getGoldCaptureScreenshotSize(maxEdge = 1920) {
  const longest = Math.max(FRAME.w, FRAME.h);
  const scale = maxEdge / longest;
  return {
    width: Math.round(FRAME.w * scale),
    height: Math.round(FRAME.h * scale),
  };
}

/**
 * Center-crop a data URL to the booth frame aspect (what the user sees in image 292).
 */
export function cropDataUrlToGoldFrame(
  dataUrl,
  {
    aspectW = FRAME.w,
    aspectH = FRAME.h,
    maxEdge = 1920,
    quality = 0.95,
    /** Auto: PNG in → PNG out (keeps Segmind transparency); JPEG in → JPEG out */
    mime,
  } = {}
) {
  const targetAspect = aspectW / aspectH;
  const outMime =
    mime || (dataUrl.startsWith('data:image/png') ? 'image/png' : 'image/jpeg');

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      let sx = 0;
      let sy = 0;
      let sw = width;
      let sh = height;
      const imgAspect = width / height;

      if (imgAspect > targetAspect) {
        sw = height * targetAspect;
        sx = (width - sw) / 2;
      } else {
        sh = width / targetAspect;
        sy = (height - sh) / 2;
      }

      const longest = Math.max(sw, sh);
      const scale = longest > maxEdge ? maxEdge / longest : 1;
      const cw = Math.round(sw * scale);
      const ch = Math.round(sh * scale);

      const canvas = document.createElement('canvas');
      canvas.width = cw;
      canvas.height = ch;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas not supported'));
        return;
      }
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);
      resolve(
        canvas.toDataURL(outMime, outMime === 'image/jpeg' ? quality : undefined)
      );
    };
    img.onerror = () => reject(new Error('Failed to load image for crop'));
    img.src = dataUrl;
  });
}
